// Module
var code = "<div class=\"mobile-main-background\"> <div class=\"mobile-poke-list\"> <div id=\"mob-pokeList\"></div> </div> </div> ";
// Exports
export default code;